import { Rocket, BadgeCheck, KeyRound, ShieldCheck } from "lucide-react";
import { Reveal, SplitLines } from "@/components/fx/Reveal";
import { SectionCta } from "@/components/SectionCta";

const CARDS = [
  { icon: Rocket, t: "Quota di avvio", d: "Brief, shooting, contenuti, impostazione campagne." },
  { icon: BadgeCheck, t: "Compenso a risultato", d: "Una percentuale della retribuzione annua, solo alla firma del contratto." },
  { icon: KeyRound, t: "Campagne a nome tuo", d: "Gli annunci girano sul tuo account, budget e dati restano tuoi." },
  { icon: ShieldCheck, t: "Garanzia 30 giorni", d: "Se la persona se ne va nel primo mese riprendiamo la ricerca e la sostituta non la paghi di nuovo." },
];

export const Pagamento = ({ id = "come-si-paga", eyebrow = "Come si paga", lines = ["Paghi a risultato,", "non a promessa."], cards = CARDS, cta = null }) => (
  <section id={id} className="rl-section relative py-28 lg:py-40" data-testid="pagamento-section">
    <div className="rl-container">
      <div className="grid gap-8 lg:grid-cols-12">
        <div className="lg:col-span-4"><p className="rl-eyebrow text-[#0F6E56]">{eyebrow}</p></div>
        <SplitLines className="rl-h2 lg:col-span-8" lines={lines} data-testid="pagamento-title" />
      </div>
      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:mt-24 lg:grid-cols-4">
        {cards.map((c, i) => (
          <Reveal key={c.t} delay={i * 100} className="rl-fade">
            <article className="rl-card group flex h-full flex-col p-7 transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-[#0F6E56] hover:shadow-[0_30px_60px_-34px_rgba(15,110,86,0.45)]" data-testid={`pagamento-card-${i}`}>
              <div className="flex items-center justify-between">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#BCE3D6]/60 text-[#0F6E56] transition-[transform,background-color,color] duration-500 group-hover:rotate-6 group-hover:bg-[#0F6E56] group-hover:text-white">
                  <c.icon size={22} />
                </span>
                <span className="font-mono-data text-sm text-[#6B6961]">0{i + 1}</span>
              </div>
              <h3 className="mt-12 text-xl tracking-[-0.02em]">{c.t}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[#2C2C2A]/80">{c.d}</p>
            </article>
          </Reveal>
        ))}
      </div>
      {cta && <SectionCta label={cta} testId="pagamento-cta" />}
    </div>
  </section>
);
